import React, { useContext, useEffect } from 'react';

import { createBrowserHistory } from 'history';
import { Route, Routes } from "react-router-dom";
import { ABOUT_URL,  CATEGORIES_URL,  COURSES_URL,  HOME_URL, LIBRARY_URL, LOGIN_URL, RESET_PASSWORD_DONE_URL, RESET_PASSWORD_URL, SEARCH_URL, SIGNUP_URL, SUGGESTION_URL } from './urls';
import { AboutPage,  HomePage, NotFound, SuggestionPage, CourseView, SearchView, CategoriesView, LibraryView, LoginPage, RegisterPage} from '../views';
import { UserContext } from '../components/provider';
import notifications from '../utils/notifications';
import { getMe } from '../utils/utils';

const {REACT_APP_BASE_BACKEND_URL} = process.env;
export const history = createBrowserHistory();

const MainRoutes = () => {
    const { user, loadingUser, setLoadingUser, setUser } = useContext(UserContext);

    useEffect(()=>{
        const sessionID = localStorage.getItem('session_id');
        const token = localStorage.getItem('jwt');
        if(user?.email){
            setLoadingUser(false);
        }
        else{
            if (sessionID){
                try {
                    const user_info = JSON.parse(sessionID);
                    if (user_info.hasOwnProperty('name') 
                        && user_info.hasOwnProperty('email')
                        && user_info.hasOwnProperty('profilePicture'))
                    {
                        const new_user = {
                            name: user_info.name,
                            email: user_info.email,
                            profilePicture: user_info.profilePicture,
                        };
                        setLoadingUser(false);
                        setUser(new_user);
                    }
                }
                catch(error) {
                    console.error(error);
                    notifications('Cannot load user profile');
                    window.localStorage.removeItem('session_id');
                }
            }
            if (!user?.email) {
                fetch(REACT_APP_BASE_BACKEND_URL + '/accounts/auth/get-current-user', {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 
                        'Content-Type': 'application/json',
                        'Authorization': `${token && `jwt ${token}`}`
                    }}).then(response => {
                        if (response.status === 204) {
                            window.localStorage.removeItem('session_id');
                            setLoadingUser(false);
                            return;
                        }
                        return response.json()
                    }).then(data => {
                        if (data) {
                            const new_user = {
                                'name': data.name,
                                'email': data.email,
                                'profilePicture': data.profile_picture,
                            }
                            if(!new_user.profilePicture){
                                new_user.profilePicture = './broken-image'
                            }
                            window.localStorage.setItem('session_id', JSON.stringify(new_user));
                            setLoadingUser(false);
                            setUser(new_user);
                        }
                    }).catch(error => {
                        setLoadingUser(false);
                        console.error(error, 'Cannot get user')
                        // notifications();
                    });
            }
        }
       
    },[]);

  return (
    <Routes>
      <Route path={HOME_URL}  element={<HomePage />} />
      <Route path={COURSES_URL}  element={<CourseView />} />
      <Route path={SEARCH_URL}  element={<SearchView />} />
      <Route path={CATEGORIES_URL}  element={<CategoriesView />} />
      <Route path={LIBRARY_URL}  element={<LibraryView />} />
      <Route path={SUGGESTION_URL}  element={<SuggestionPage />}/>
      <Route path={ABOUT_URL}  element={<AboutPage/>}/>
      <Route path={LOGIN_URL}  element={<LoginPage/>}/>
      <Route path={SIGNUP_URL}  element={<RegisterPage/>}/>
      <Route path={RESET_PASSWORD_URL}  element/>
      <Route path={RESET_PASSWORD_DONE_URL}  element/>

      <Route path='*'  element={<NotFound />} />
    </Routes>
  );
};

export default MainRoutes;
